import React from "react";
import { CroppedScreenshot } from "../components/croppedImage.tsx";
import { api_domain } from "../config"

export function AdTile(props) {
    let ads = props.results.items
    let cur_page = props.results.page
    let page_size = props.results.size
    let total = props.results.total
    return (
        <div>
            <p className="batchTwo">
                Showing {(cur_page - 1) * page_size + 1}-{(cur_page - 1) * page_size + ads.length} of {total} {total === 1 ? "ad" : "ads"}
                &nbsp;
                  {cur_page === 1 ? <button disabled className="buttonBatch" >&#8249;</button> : <button className="buttonBatch" onClick={props.prev_page}>&#8249;</button>}
                &nbsp;
                 {cur_page === Math.ceil(total / page_size) ? <button disabled className="buttonBatch" >&#8250;</button> : <button className="buttonBatch" onClick={props.next_page}>&#8250;</button> }
            </p>
            <div style={{ "marginLeft": "20px", "marginRight": "20px", "justifyContent": "space-between" }}>
                {ads.map((ad) => (
                    <div key={ad.id} style={{ "border": "1px solid black", "border": "1px solid #DBDADD", "borderRadius": "8px", "padding": "5px", "margin": "0px" }}>
			<CroppedScreenshot ad={ad} blur={props.blur} url={`${api_domain}/i/${ad.path_to_image}`}/>
                        <p><b>ad id:</b> <a href={`/ad/${ad.id}/?blur=${props.blur}`}>{ad.id}</a></p>
                        <p><b>batch id:</b> <a href={`/batch/${ad.batch_id}`}>{ad.batch_id}</a></p>
                        <p><b>capture date:</b> {new Date(ad.capture_timestamp).toLocaleDateString("en-US")}</p>
                        <p><b>parent domain:</b> {ad.parent_url === "Not Found" ? <a href={ad.parent_url}>{"Not Found"}</a> : <a href={ad.parent_url}>{new URL(ad.parent_url).hostname}</a>}</p>
                        <p><b>landing domain:</b> {ad.landing_url === "Not Found" ? <a href={ad.landing_url}>{"Not Found"}</a> : <a href={ad.landing_url}>{new URL(ad.landing_url).hostname}</a>}</p>
			<p><b>description:</b> {ad.text_description}</p>
                    </div>
                ))}
            </div>
        </div>)
}
